import { Autocomplete, TextField } from "@mui/material"

export function ConditionValueScheduleCode({ value, onChange }) {
    const selected = Array.isArray(value) ? value : value ? [value] : []

    return (
        <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={selected}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} placeholder="Type schedule codes and press Enter..." />}
        />
    )

    function handleChange(_, newValue) {
        onChange(newValue)
    }
}
